import {memo, ReactNode} from 'react';

import {capitalize} from 'lodash';
import {useTranslation} from 'react-i18next';

interface SplitResultDetailsProps {
  total: number;
  payer: string;
  description: string;
}

interface SplitResultDetailRowProps {
  label: string;
  value: ReactNode;
}

const SplitResultDetailRow = ({label, value}: SplitResultDetailRowProps) => (
  <div className="split-result-detail-row">
    <span className="split-result-detail-label">{label}</span>
    <span className="split-result-detail-value">{value}</span>
  </div>
);

export const SplitResultDetails = memo(
  ({total, payer, description}: SplitResultDetailsProps) => {
    const {t} = useTranslation();

    return (
      <div className="split-result-details">
        <SplitResultDetailRow
          label={t('split_bills_page.total_amount')}
          value={`$${total.toFixed(2)}`}
        />
        <SplitResultDetailRow
          label={t('split_bills_page.paid_by')}
          value={capitalize(payer)}
        />
        {description && (
          <SplitResultDetailRow
            label={t('split_bills_page.description_label')}
            value={description}
          />
        )}
      </div>
    );
  },
);
